import { ReactNode } from 'react'

import styles from './intro.module.css'

export interface EvIntroProps {
  introText: ReactNode
}
export const EvIntro = ({ introText }: EvIntroProps) => (
  <section>
    <div className={styles.evIntroText}>{introText}</div>
  </section>
)
